import styled from '@emotion/styled'

const StyledSwitch = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  align-items: center;
  /* border:1px solid pink; */
`
export default StyledSwitch
